// Кироса — trigger: «В конце хода: если HP моего Героя > HP вражеского Героя — +2 Влияния».

import { addInfluence } from './influence.js';

export const HERO_ID = 'deus_kirosa';

export function kirosaEot(state, playerIdx) {
  const p = state.players[playerIdx];
  const enemy = state.players[1 - playerIdx];
  if (!p || p.hero.id !== HERO_ID) return;
  if (p.hero.hp > enemy.hero.hp) {
    addInfluence(state, playerIdx, 2, 'Кироса [конец хода: HP выше]');
  }
}
